import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllWithoutPagination as getAll } from "../services/trip-route.service";

// Define initial state
const initialState = {
    data: [],
    loading: false,
    error: null,
};

// Define the async thunk
export const fetchData = createAsyncThunk(
    "tripRoute/fetchData",
    async (_, { getState }) => {
        const { data } = getState().tripRoute;
        if (data.length > 0) {
            return data;
        }
        try {
            const response = await getAll();
            return response.data?.data;
        } catch (error) {
            throw Error("Failed to fetch data");
        }
    }
);

// Define the slice
const tripRouteSlice = createSlice({
    name: "tripRoute",
    initialState,
    reducers: {
        clearData: (state) => {
            state.data = [];
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

// Export the actions and reducer
export const { clearData } = tripRouteSlice.actions;
export default tripRouteSlice.reducer;
